import { ColorVariant } from '@makyoapp/makyo-tw-ui'

import { useUpdateCompSettingValue } from '@/hooks/useUpdateCompSettings'
import { BuilderComponentSetting } from '@/shared/builder'
import { BrandKitColorsDropdown } from '@/components/BrandKitColorsDropdown'

interface ColorVariantFieldSettingProps {
  id: string
  settingId: string
  value: any
  defaultValue: ColorVariant
  compSettings: Record<string, any>
  colorVariantSettings: BuilderComponentSetting['colorVariantSettings']
}

const ColorVariantFieldSetting = ({
  id,
  settingId,
  value,
  defaultValue,
  compSettings,
  colorVariantSettings,
}: ColorVariantFieldSettingProps) => {
  const updateValue = useUpdateCompSettingValue(id)

  const { schemeId, fullColor: colorType = 'both', showExtendedColors = true } = colorVariantSettings ?? {}

  return (
    <BrandKitColorsDropdown
      id={settingId}
      type={colorType}
      schemeId={schemeId ? compSettings[schemeId] : undefined}
      value={value || defaultValue}
      onChange={updateValue}
      showExtendedColors={showExtendedColors}
    />
  )
}

export default ColorVariantFieldSetting
